import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) localStorage.setItem("zeeptel_ref", ref.toUpperCase());
    loadUser();
  }, [loadUser]);

  const login = async (email, password, remember = false) => {
    const { data } = await api.post("/auth/login", { email, password, remember });
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password, phone = "") => {
    const referral_code = localStorage.getItem("zeeptel_ref") || "";
    const { data } = await api.post("/auth/register", { name, email, password, phone, referral_code });
    localStorage.removeItem("zeeptel_ref");
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (e) {
      return null;
    }
  }, []);

  const setBalance = (balance) => {
    setUser((u) => (u ? { ...u, balance } : u));
  };

  const setUserData = (data) => setUser(data);

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser, setBalance, setUserData }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
